import { useApproveBooking, useRejectBooking, useCancelBooking, useNoShowBooking } from '@hooks/useBookings';
import type { Booking } from '@api/types';
import * as Icons from '@components/Icons';
import { RowMenu, type RowMenuItem } from '@components/admin/RowMenu';

export type MenuItem = RowMenuItem;
export { RowMenu };

export function RowMenuWithActions({ booking, onOpen }: { booking: Booking; onOpen: () => void }) {
  const approveMutation = useApproveBooking();
  const rejectMutation = useRejectBooking();
  const cancelMutation = useCancelBooking();
  const noShowMutation = useNoShowBooking();
  const isPending         = booking.status === 'pending';
  const isPendingApproval = booking.status === 'pending_clinic_approval';
  const isConfirmed       = booking.status === 'confirmed';

  const items: (MenuItem | null)[] = [
    { icon: Icons.Eye, label: 'Ver detalle', onClick: onOpen },
    null,
    ...(isPending || isPendingApproval ? [
      { icon: Icons.Check, label: 'Aprobar reserva', onClick: () => { approveMutation.mutate(booking.id); } } as MenuItem,
    ] : []),
    ...(isPendingApproval ? [
      { icon: Icons.X, label: 'Rechazar reserva', tone: 'danger', onClick: () => { rejectMutation.mutate(booking.id); } } as MenuItem,
    ] : []),
    ...(isConfirmed ? [
      { label: 'No presentado', onClick: () => { noShowMutation.mutate(booking.id); } } as MenuItem,
    ] : []),
    { icon: Icons.X, label: 'Cancelar reserva', tone: 'danger', onClick: () => { cancelMutation.mutate({ id: booking.id }); } },
  ];

  return <RowMenu items={items} />;
}
